import { render, staticRenderFns } from "./progressTasks.vue?vue&type=template&id=156e2032&"
import script from "./progressTasks.vue?vue&type=script&lang=js&"
export * from "./progressTasks.vue?vue&type=script&lang=js&"
import style0 from "./progressTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports